import { DataProvider } from "../helpers"

import { Enums } from "../models/common"
import { OpActor, OpActorGroup } from "../models/core"
import { ColumnInfo } from "../models/custom"

export class DataProviderActor {

    // Ctor

    constructor(private dataProvider: DataProvider) { }

    // Ctor End


    // Public Methods
    
    public deleteActor = (opObj: OpActor): JQueryPromise<OpActor> => {
        return this.dataProvider
            .sendRequestWithSession('OpxDeleteActor', { ToBeDeleted: opObj.toJSON() }, null)
            .then(data => {
                const result: OpActor = new OpActor(data)

                OpActor.loadNavigationProperties(this.dataProvider, [result])

                return result
            })
    }

    public getActor = (id: number): JQueryPromise<OpActor> => {
        return this.dataProvider
            .sendRequestWithSession('OpxGetActor', { IdActor: id }, 'OpxGetActorResult')
            .then(data => {
                const result: OpActor = new OpActor(data)

                OpActor.loadNavigationProperties(this.dataProvider, [result])

                return result
            })
    }

    public getActorFilter = (columns: ColumnInfo[], pageNbr: number, pageSize: number, customWhereClause: string) => {
        return this.dataProvider.sendFilterRequestWithSession<OpActor>(columns, pageNbr, pageSize, customWhereClause, Enums.ReferenceType.IdActor, 'OpxActorFilter', 'OpxActorFilterResult')
    }

    public getActorGroupFilter = (columns: ColumnInfo[], pageNbr: number, pageSize: number, customWhereClause: string) => {
        const whereClause = customWhereClause === '' ? null : customWhereClause

        return this.dataProvider.sendFilterRequestWithSession<OpActorGroup>(columns, pageNbr, pageSize, whereClause, Enums.ReferenceType.IdActorGroup, 'OpxActorGroupFilter', 'OpxActorGroupFilterResult')
    }


    public saveActor = (opObj: OpActor): JQueryPromise<OpActor> => {
        return this.dataProvider
            .sendRequestWithSession('OpxSaveActor', { ToBeSaved: opObj.toJSON() }, 'OpxSaveActorResult')
            .then(data => {
                const result: OpActor = new OpActor(data)

                OpActor.loadNavigationProperties(this.dataProvider, [result])

                return result
            })
    }

    // Public Methods End
}